import React from 'react';
import BlockHeading from "../components/BlockHeading";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment'

const nameLabelObj = {
    lastName: "Last Name:",
    firstName: "First Name:",
    middleName: "Middle Name:",
}
const addressLabelObj = {
    address: "Address:",
    address2: "Address 2:",
    city: "City:",
    state: "State:", 
    zipCode: "ZIP Code:"
}
const contactLabelObj = {
    cellNumber: "Cell Number:",
    homePhone: "Home Phone:",
    emailAddress: "Email Address:"
}
const reviewFieldsObj = [
    {
        title: "Information",
        ...nameLabelObj,
        dateOfBirth: "Date of Birth:",
        last4OfSSN: "Last 4 of SSN:"
    },
    {
        title: "Permanent Address",
        ...addressLabelObj
    },
    {
        title: "Contact Information",
        ...contactLabelObj
    },
    {
        title: "How did you hear about us?",
    },
   
    {
        title: "Current Education",
        currEdutype: "High School or College:",
        hsName: "School Name:",
        hsAddress: "School Address:",
        hsAddress2: "School Address 2:",
        hsCity: "School City:",
        hsState: "School State:",
        hsZipCode: "School ZIP Code:",
        hsgraduationDate: "Graduation Date:",
        hsPhNo: "School Phone Number:",
        hsAdvisorTitle: "School Advisor Name",
        hsAdvisorFName: "First Name:",
        hsAdvisorLName: "Last Name:"
    },
    {
        title: "College",
        currEdutype: "High School or College:",
        collegeName: "College Name:",
        collegeAddTitle: "College Address",
        collegeAddress: "College Address:",
        collegeAddress2: "College Address 2:",
        collegeCity: "College City:",
        collegeState: "College State:",
        collegeZipCode: "College ZIP Code:",
        collegegraduationDate: "Anticipated Graduation Date:",
        collegePhNo: "College Phone Number:",
        collegeAdvisorTitle: "College Advisor Name",
        collegeAdvisorFName: "First Name:",
        collegeAdvisorLName: "Last Name:"
    },
    {
        title: "Parent or Guardian",
        parentOrGuardian: "Parent or Guardian:",
        PGnameTitle: "Name:",
        ...nameLabelObj,
        ...addressLabelObj,
        ...contactLabelObj
    },
    {
        title: "Household Income",
        householdIncome: "Previous year's household income:",
        householdTax: "Previous year's tax return:"
    },
    {
        title: "College or University Considering",
        colleges: ["College 1:", "College 5:", "College 2:", "College 6:",
            "College 3:", "College 7:", "College 4:", "College 8:"]
    }

]

const StudentReviewDetails = (props) => {

    const {details} = props;
    const renderMdBlock = (label, value, size) => {
        return <Col md={size}>
            <p className="mb-0 ">
                <strong>{label}</strong></p>
            <p>{value}</p>
        </Col>
    }

    let dob=moment(details.dateOfBirth).format("MM/DD/YYYY")
    let graduationDate = moment(details.educationDetails.graduationDate).format("MM/DD/YYYY")


    return (
        <div>
            <BlockHeading title={`${props.hrTag ? 'Student' : 'Your'} ${reviewFieldsObj[0].title}`} 
            hrTag={props.hrTag} />
            <Row >
                {renderMdBlock(reviewFieldsObj[0].lastName, details.lastName, 4)}
                {renderMdBlock(reviewFieldsObj[0].firstName, details.firstName, 4)}
                {renderMdBlock(reviewFieldsObj[0].middleName, details.middleName, 4)}
                {renderMdBlock(reviewFieldsObj[0].dateOfBirth, dob, 4)}
                {renderMdBlock(reviewFieldsObj[0].last4OfSSN, details.last4ofSSN, 4)}
            </Row>
            <hr />
            <BlockHeading title={`${props.hrTag ? 'Student' : 'Your'}  ${reviewFieldsObj[1].title}`} 
            hrTag={props.hrTag} />
            <Row >
                {renderMdBlock(reviewFieldsObj[1].address, details.streetAddress, 7)}
                {renderMdBlock(reviewFieldsObj[1].address2, details.address2, 5)}
                {renderMdBlock(reviewFieldsObj[1].city, details.city, 4)}
                {renderMdBlock(reviewFieldsObj[1].state, details.stateCode, 4)}
                {renderMdBlock(reviewFieldsObj[1].zipCode, details.zipCode, 4)}
            </Row>
            <hr />
            <BlockHeading title={reviewFieldsObj[2].title} hrTag={props.hrTag} />
            <Row >
                {renderMdBlock(reviewFieldsObj[2].cellNumber, details.cellNumber, 4)}   
                {renderMdBlock(reviewFieldsObj[2].homePhone, details.homePhone, 4)}
                {renderMdBlock(reviewFieldsObj[2].emailAddress, details.emailAddress, 4)}
            </Row>
            <hr />
            <BlockHeading title={reviewFieldsObj[3].title} hrTag={props.hrTag} />
            <p className="mb-0">
                <strong>{reviewFieldsObj[3].title}</strong></p>
            <p>{details.wayOfReach}</p>
            <hr />



            <BlockHeading title={reviewFieldsObj[4].title} hrTag={props.hrTag} />
            
            {details.educationDetails.educationType === "High School" && <Row >
            {renderMdBlock(reviewFieldsObj[4].currEdutype, details.educationDetails.educationType, 4)}
                {renderMdBlock(reviewFieldsObj[4].hsName, details.educationDetails.name, 8)}
                {renderMdBlock(reviewFieldsObj[4].hsAddress, details.educationDetails.address, 7)}
                {renderMdBlock(reviewFieldsObj[4].hsAddress2, details.educationDetails.address2, 5)}
                {renderMdBlock(reviewFieldsObj[4].hsCity, details.educationDetails.city, 6)}
                {renderMdBlock(reviewFieldsObj[4].hsState, details.educationDetails.state, 3)}
                {renderMdBlock(reviewFieldsObj[4].hsZipCode, details.educationDetails.zipCode, 3)}
                {renderMdBlock(reviewFieldsObj[4].hsgraduationDate, graduationDate, 4)}
                {renderMdBlock(reviewFieldsObj[4].hsPhNo, details.educationDetails.phoneNumber, 8)}
                {renderMdBlock(<strong className="h4">{reviewFieldsObj[4].hsAdvisorTitle}</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[4].hsAdvisorFName, details.educationDetails.advisorFirstName, 4)}
                {renderMdBlock(reviewFieldsObj[4].hsAdvisorLName, details.educationDetails.advisorLastName, 4)}
            </Row>}
            {details.educationDetails.educationType === "College" &&<Row >
            {renderMdBlock(reviewFieldsObj[5].currEdutype, details.educationDetails.educationType, 4)}
                {renderMdBlock(reviewFieldsObj[5].collegeName, details.educationDetails.name, 8)}
                {renderMdBlock(reviewFieldsObj[5].collegeAddress, details.educationDetails.address, 7)}
                {renderMdBlock(reviewFieldsObj[5].collegeAddress2, details.educationDetails.address2, 5)}
                {renderMdBlock(reviewFieldsObj[5].collegeCity, details.educationDetails.city, 6)}
                {renderMdBlock(reviewFieldsObj[5].collegeState, details.educationDetails.state, 3)}
                {renderMdBlock(reviewFieldsObj[5].collegeZipCode, details.educationDetails.zipCode, 3)}
                {renderMdBlock(reviewFieldsObj[5].collegegraduationDate, graduationDate, 4)}
                {renderMdBlock(reviewFieldsObj[5].collegePhNo, details.educationDetails.phoneNumber, 8)}
                {renderMdBlock(<strong className="h4">{reviewFieldsObj[5].collegeAdvisorTitle}</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[5].collegeAdvisorFName, details.educationDetails.advisorFirstName, 4)}
                {renderMdBlock(reviewFieldsObj[5].collegeAdvisorLName, details.educationDetails.advisorLastName, 4)}
            </Row>}
            <hr />



            <BlockHeading title={`${reviewFieldsObj[6].title} 1`} hrTag={props.hrTag} />
            <Row >
                {renderMdBlock(reviewFieldsObj[6].parentOrGuardian, details.parentOrGuardianDetails.type, 12)}
                {renderMdBlock(<strong className="h4">Name:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].lastName,details.parentOrGuardianDetails.pG1LastName, 4)}
                {renderMdBlock(reviewFieldsObj[6].firstName, details.parentOrGuardianDetails.pG1FirstName, 4)}
                {renderMdBlock(reviewFieldsObj[6].middleName, details.parentOrGuardianDetails.pG1MiddleName, 4)}
                {renderMdBlock(<strong className="h4">Address:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].address, details.parentOrGuardianDetails.pG1Address, 7)}
                {renderMdBlock(reviewFieldsObj[6].address2, details.parentOrGuardianDetails.pG1Address2, 5)}
                {renderMdBlock(reviewFieldsObj[6].city, details.parentOrGuardianDetails.pG1City, 4)}
                {renderMdBlock(reviewFieldsObj[6].state, details.parentOrGuardianDetails.pG1StateCode, 4)}
                {renderMdBlock(reviewFieldsObj[6].zipCode, details.parentOrGuardianDetails.pG1ZipCode, 4)}
                {renderMdBlock(<strong className="h4">Contact Information:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].cellNumber, details.parentOrGuardianDetails.pG1CellNumber, 4)}
                {renderMdBlock(reviewFieldsObj[6].homePhone, details.parentOrGuardianDetails.pG1HomePhone, 4)}
                
                {renderMdBlock(reviewFieldsObj[6].emailAddress, details.parentOrGuardianDetails.pG1EmailAddress, 4)}
            </Row>
            {details.parentOrGuardianDetails.checkPG2 !== "1"&&<hr />}
            {details.parentOrGuardianDetails.checkPG2 !== "1"&&
            <BlockHeading title={`${reviewFieldsObj[6].title} 2`} hrTag={props.hrTag} />}
            {details.parentOrGuardianDetails.checkPG2 !== "1"&&
            <Row >
                {renderMdBlock(reviewFieldsObj[6].parentOrGuardian, details.parentOrGuardianDetails.type2, 12)}
                {renderMdBlock(<strong className="h4">Name:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].lastName, details.parentOrGuardianDetails.pG2LastName, 4)}
                {renderMdBlock(reviewFieldsObj[6].firstName, details.parentOrGuardianDetails.pG2FirstName, 4)}
                {renderMdBlock(reviewFieldsObj[6].middleName, details.parentOrGuardianDetails.pG2MiddleName, 4)}
                {renderMdBlock(<strong className="h4">Address:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].address, details.parentOrGuardianDetails.pG2Address, 7)}
                {renderMdBlock(reviewFieldsObj[6].address2, details.parentOrGuardianDetails.pG2Address2, 5)}
                {renderMdBlock(reviewFieldsObj[6].city, details.parentOrGuardianDetails.pG2City, 4)}
                {renderMdBlock(reviewFieldsObj[6].state, details.parentOrGuardianDetails.pG2StateCode, 4)}
                {renderMdBlock(reviewFieldsObj[6].zipCode, details.parentOrGuardianDetails.pG2ZipCode, 4)}
                {renderMdBlock(<strong className="h4">Contact Information:</strong>, "", 12)}
                {renderMdBlock(reviewFieldsObj[6].cellNumber, details.parentOrGuardianDetails.pG2CellNumber, 4)}
                {renderMdBlock(reviewFieldsObj[6].homePhone, details.parentOrGuardianDetails.pG2HomePhone, 4)}
                
                {renderMdBlock(reviewFieldsObj[6].emailAddress, details.parentOrGuardianDetails.pG2EmailAddress, 4)}
            </Row>}
            <hr />
            <BlockHeading title={reviewFieldsObj[7].title} hrTag={props.hrTag} />
            <Row>
                {renderMdBlock(reviewFieldsObj[7].householdIncome, details.parentOrGuardianDetails.houseHoldIncome, 4)}
                {renderMdBlock(reviewFieldsObj[7].householdTax, details.parentOrGuardianDetails.taxReturn, 4)}
            </Row>
            <hr />
            <BlockHeading title={reviewFieldsObj[8].title} hrTag={props.hrTag} />
            <Row>
                    <Col  md={6} >
                        {renderMdBlock("College 1:",details.collegeDetails.college1 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 2:",details.collegeDetails.college2 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 3:",details.collegeDetails.college3 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 4:",details.collegeDetails.college4 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 5:",details.collegeDetails.college5 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 6:",details.collegeDetails.college6 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 7:",details.collegeDetails.college7 , 12)}
                    </Col>
                    <Col  md={6} >
                        {renderMdBlock("College 8:",details.collegeDetails.college8 , 12)}
                    </Col>
            </Row>
            <hr />
            <p className="mb-0">
                <strong>Possible area(s) of academic concentration/major:</strong>
            </p>
            <p>{details.collegeDetails.possibleAreas}</p>
            <hr />
            <p className="mb-0">
                <strong>Special Consideration:</strong></p>
            <p>{details.collegeDetails.specialConsideration}</p>
            <hr />
            {props.hrTag ? null : <BlockHeading title={`Work Experience, School & Community Activities`} 
            hrTag={props.hrTag} />}
            <p className="mb-0">
                <strong>Work Experience:</strong></p>
            <p>{details.activities.workExperience}</p>
            <hr />
            <p className="mb-0">
                <strong>School Activities:</strong></p>
            <p>{details.activities.schoolActivities}</p>
            <hr />
            <p className="mb-0">
                <strong>Community Ativities:</strong></p>
            <p>{details.activities.communityActivities}</p>
            <hr />
        </div>
    );
}
export default StudentReviewDetails;